<script>
import TopBar from "@components/top-bar";
import NavBar from "@components/nav-bar";
import RightBar from "@components/right-bar";
import Footer from "@components/footer";
import appStore from "@/src/state/appStore";

export default {
  components: { TopBar, NavBar, RightBar, Footer },
  props: ["showMenu"],
  data() {
    return {
      isMenuOpened: false,
      user: this.$store ? this.$store.state.auth.token : {} || {}
    };
  },
  computed: {
    wrapperPadding() {
      return this.$route.meta.showSubmenu &&
        appStore.getters.subMenuItems.length > 0
        ? 132
        : 65;
    }
  },

  methods: {
    toggleMenu() {
      this.isMenuOpened = !this.isMenuOpened;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    }
  }
};
</script>

<template>
  <div>
    <header id="topnav">
      <TopBar :user="user" />
      <NavBar v-if="this.$route.meta.showSubmenu" :is-menu-opened="isMenuOpened" />
    </header>

    <div class="wrapper" v-bind:style="{paddingTop: wrapperPadding + 'px'}">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">&nbsp;</div>
        </div>
        <slot />
      </div>
      <Footer />
      <RightBar />
    </div>
  </div>
</template>
